import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Grid,
  Button,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import axios from 'axios';
import ConferenceNavbar from "../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";

const ConferenceViewTermsAndConditions = () => {
  const eventid = localStorage.getItem('eventid');
  const [englishTerms, setEnglishTerms] = useState('');
  const [arabicTerms, setArabicTerms] = useState('');
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`/api/conference/index-terms-and-conditions?id=${eventid}`);
        setEnglishTerms(response.data.terms_en || '');
        setArabicTerms(response.data.terms_ar || '');
      } catch (error) {
        setEnglishTerms('');
        setArabicTerms('');
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, [eventid]);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 15, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#f5f7fa',
      }}
    >
      <ConferenceNavbar />

      <Container
        maxWidth="lg"
        sx={{
          mt: 10,
          mb: 10,
          flexGrow: 1,
          paddingBottom: '80px',
        }}
      >
        <Button
        sx={{  float: 'right'}}
        variant="contained"
        onClick={() => {
          window.close(); // Close current tab
          window.opener?.focus(); // Return focus to original tab
        }}
      >
          Close and Return
        </Button>
        <Grid container spacing={4} alignItems="stretch">
          {/* English Terms - Left Side */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                p: isMobile ? 2 : 4,
                borderRadius: 2,
                backgroundColor: theme.palette.background.paper,
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: 6,
                },
              }}
            >
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontSize: { xs: '1.8rem', sm: '2.2rem' },
                    fontWeight: 600,
                    color: theme.palette.primary.main,
                    textAlign: 'left'
                  }}
                >
                  Terms and Conditions
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary" textAlign="left">
                  Welcome to our event registration platform. By accessing or using our services,
                  you agree to comply with and be bound by the following terms and conditions.
                </Typography>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  direction: 'ltr',
                  textAlign: 'left',
                  whiteSpace: 'pre-line',
                  p: 3,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 1,
                  backgroundColor: theme.palette.grey[50],
                }}
              >
                {englishTerms || 'No English terms and conditions available.'}
              </Box>
            </Paper>
          </Grid>

          {/* Arabic Terms - Right Side */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                p: isMobile ? 2 : 4,
                borderRadius: 2,
                backgroundColor: theme.palette.background.paper,
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: 6,
                },
              }}
            >
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontSize: { xs: '1.8rem', sm: '2.2rem' },
                    fontWeight: 600,
                    color: theme.palette.primary.main,
                    textAlign: 'right'
                  }}
                >
                  الشروط والأحكام
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary" textAlign="right">
                  مرحبًا بكم في منصة تسجيل فعالياتنا. باستخدام خدماتنا، فإنكم توافقون على الامتثال للشروط والأحكام التالية والالتزام بها.
                </Typography>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  direction: 'rtl',
                  textAlign: 'right',
                  whiteSpace: 'pre-line',
                  p: 3,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 1,
                  backgroundColor: theme.palette.grey[50],
                }}
              >
                {arabicTerms || 'لا توجد شروط وأحكام باللغة العربية.'}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ mt: 'auto' }}>
        <NewVersionAbstractFooter />
      </Box>
    </Box>
  );
};

export default ConferenceViewTermsAndConditions;